/**
 * <s-deal-countdown data-end="EPOCH_SECONDS" data-prefix="Ends in" [data-format="boxes"]>
 * Counts down to a real deal end date. Text mode writes "Ends in 3d 4h 5m".
 * Boxes mode fills [data-unit="d|h|m|s"] children every second.
 * When the deal ends, hides every [data-deal] element and resets bundle quantity to 1.
 */
class DealCountdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.end = Number(this.dataset.end) * 1000;
    if (!this.end) return;
    this.boxes = this.dataset.format === 'boxes';
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const left = this.end - Date.now();
    if (left <= 0) {
      window.clearInterval(this.#timer);
      document.querySelectorAll('[data-deal]').forEach((el) => {
        el.hidden = true;
        el.querySelectorAll('input[name="quantity"]').forEach((input) => {
          input.checked = input.value === '1';
        });
      });
      return;
    }
    const days = Math.floor(left / 86400000);
    const hours = Math.floor((left % 86400000) / 3600000);
    const minutes = Math.floor((left % 3600000) / 60000);
    const seconds = Math.floor((left % 60000) / 1000);

    if (this.boxes) {
      const values = { d: days, h: hours, m: minutes, s: seconds };
      this.querySelectorAll('[data-unit]').forEach((el) => {
        const value = values[el.getAttribute('data-unit')];
        el.textContent = String(value ?? 0).padStart(2, '0');
      });
      return;
    }
    const pad = (n) => String(n).padStart(2, "0");
    const clock = `${hours}h ${pad(minutes)}m ${pad(seconds)}s`;
    const parts = days > 0 ? `${days}d ${clock}` : clock;
    this.textContent = `${this.dataset.prefix || ''} ${parts}`.trim();
  }
}

if (!customElements.get('s-deal-countdown')) customElements.define('s-deal-countdown', DealCountdown);
